// Reusable inline rename input. Renders a small input that auto-focuses,
// commits on Enter / blur, cancels on Escape.
import { useEffect, useRef, useState } from "react";

export function InlineRename({ value, onCommit, onCancel, className = "", testId }) {
  const [draft, setDraft] = useState(value);
  const ref = useRef(null);

  useEffect(() => {
    ref.current?.focus();
    ref.current?.select();
  }, []);

  const commit = () => {
    const next = draft.trim();
    if (!next || next === value) onCancel();
    else onCommit(next);
  };

  return (
    <input
      ref={ref}
      data-testid={testId}
      value={draft}
      onChange={(e) => setDraft(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter") { e.preventDefault(); commit(); }
        else if (e.key === "Escape") { e.preventDefault(); onCancel(); }
      }}
      onBlur={commit}
      onClick={(e) => e.stopPropagation()}
      className={[
        "w-full rounded-md border border-primary/50 bg-background px-1.5 py-0.5 text-[12.5px] text-foreground outline-none ring-2 ring-primary/20",
        className,
      ].join(" ")}
    />
  );
}
